var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: _vm.tituloModal } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            xs12: "",
                                            sm12: "",
                                            md12: ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-textarea",
                                            _vm._g(
                                              {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  label:
                                                    _vm.formFields.glosa.label,
                                                  "error-messages": _vm.errors.collect(
                                                    _vm.formFields.glosa.id
                                                  ),
                                                  "data-vv-name":
                                                    _vm.formFields.glosa.id,
                                                  disabled: _vm.modoVer,
                                                  hint:
                                                    "Glosa que contendrá el enunciado del certificado."
                                                },
                                                model: {
                                                  value:
                                                    _vm.formFields.glosa.value,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formFields.glosa,
                                                      "value",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formFields.glosa.value"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _c("span", [
                                _c("p", [_vm._v("Puede usar los comodines:")]),
                                _c("ul", [
                                  _c("li", [
                                    _c(
                                      "strong",
                                      {
                                        domProps: {
                                          innerHTML: _vm._s(_vm.Flota)
                                        }
                                      },
                                      [_vm._v("Flota ")]
                                    ),
                                    _vm._v(
                                      ": Para insertar el nombre de la flota.\n                  "
                                    )
                                  ]),
                                  _c("li", [
                                    _c("strong", {
                                      domProps: { innerHTML: _vm._s(_vm.Rut) }
                                    }),
                                    _vm._v(
                                      ": Para insertar el rut de la flota.\n                  "
                                    )
                                  ]),
                                  _c("li", [
                                    _c("strong", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.Direccion)
                                      }
                                    }),
                                    _vm._v(
                                      ": Para insertar la dirección comercial.\n                  "
                                    )
                                  ]),
                                  _c("li", [
                                    _c("strong", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.Marca_GPS)
                                      }
                                    }),
                                    _vm._v(
                                      ": Para insertar la marca del gps instalado.\n                  "
                                    )
                                  ]),
                                  _c("li", [
                                    _c("strong", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.Modelo_Gps)
                                      }
                                    }),
                                    _vm._v(
                                      ": Para insertar el modelo del gps instalado.\n                  "
                                    )
                                  ]),
                                  _c("li", [
                                    _c("strong", {
                                      domProps: { innerHTML: _vm._s(_vm.sim) }
                                    }),
                                    _vm._v(
                                      ": Para insertar el número de Sim.\n                  "
                                    )
                                  ]),
                                  _c("li", [
                                    _c("strong", {
                                      domProps: { innerHTML: _vm._s(_vm.telco) }
                                    }),
                                    _vm._v(
                                      ": Para insertar la compañia de telecomunicaciones.\n                  "
                                    )
                                  ])
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.activo.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstado,
                                  readonly: _vm.modoVer
                                },
                                on: { change: _vm.cambioEstadoSwitch },
                                model: {
                                  value: _vm.formFields.activo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.activo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.activo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  label: _vm.formFields.anexo.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.glosa.id
                                  ),
                                  "data-vv-name": _vm.formFields.anexo.id,
                                  disabled: _vm.soloLectura || _vm.modoVer,
                                  hint:
                                    "Anexo que contendra la bajada del certificado.."
                                },
                                model: {
                                  value: _vm.formFields.anexo.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.anexo, "value", $$v)
                                  },
                                  expression: "formFields.anexo.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }